// extracted by mini-css-extract-plugin
export default {"root":"IconArrowLeft_root__8i5cY"};